<template>
  <div>
    <vx-card collapse-action refresh-content-action title="FMCSA Reports">
      <div class="flex flex-col gap-8">
        <div class="flex gap-4 self-end">
          <vs-input @input="searchChanged" type="text" placeholder="Search" v-model="searchText" />
          <vs-button @click="modalAction('days-modal', true)">DOT INSPECTION DAYS</vs-button>
          <vs-button @click="modalAction('create-modal', true)">New Report</vs-button>
        </div>
        <FmcsaTable :tableData="table" />
      </div>
    </vx-card>

    <CreateModal @cancel="modalAction('create-modal', false)" v-if="createModalOpen" />
    <DaysModal @cancel="modalAction('days-modal', false)" v-if="daysModalOpen" />

  </div>
</template>

<script>
import FmcsaTable from './components/FmcsaTable/FmcsaTable.vue';
import CreateModal from './components/CreateModal/CreateModal.vue';
import DaysModal from './components/DaysModal/DaysModal.vue';

export default {
  components: {
    FmcsaTable,
    CreateModal,
    DaysModal
  },
  data() {
    return {
      name: "SearchAndButtons",
      searchText: '',
      daysModalOpen: false,
      createModalOpen: false,
    }
  },
  methods: {
    modalAction(name, value) {
      switch (name) {
        case 'days-modal':
          this.daysModalOpen = value
          break;

        case 'create-modal':
          this.createModalOpen = value
          break;

        default:
          break;
      }
    },
    searchChanged() {
      this.$store.dispatch('fmcsaReports/fetchTable', { search: this.searchText })
    }
  },
  created() {
    this.$store.dispatch('fmcsaReports/fetchTable')
  },
  computed: {
    table() {
      return this.$store.state.fmcsaReports.table;
    },
  }
};
</script>

<style lang="scss" scoped></style>
